import { ConnectionType } from 'connection/types'
import { TradeType } from 'store/market/types'
import { MuiThemeType } from 'styles/Themes'

export interface MandatoryToastType {
  id: number
  expirationTime: number
  content: string
  createdAt: number
  notifyType: number
  title: string
}

export enum TifType {
  GTC = 'Good-Till-Time',
  IOC = 'Immediate-Or-Cancel',
  FOK = 'Fill-Or-Kill',
}

export interface PreferenceType {
  orderConfirmation: boolean
  fundChange: boolean
}

export enum EFavoriteAssetsElements {
  Balance = 'Balance',
  TotalMargin = 'TotalMargin',
  AvailableMargin = 'AvailableMargin',
  PositionValue = 'PositionValue',
  UnPnl = 'UnPnl',
  Leverage = 'Leverage',
  Risk = 'Risk',
}

export interface SettingState {
  theme: MuiThemeType
  connectorName: ConnectionType | undefined
  showPortfolio: boolean
  save: boolean
  mandatoryToast: MandatoryToastType
  tif: Record<TradeType, TifType>
  preferences: PreferenceType
  favoriteAssetsElements: Array<EFavoriteAssetsElements>
}
